try{self['workbox:google-analytics:4.1.1']&&_()}catch(e){}// eslint-disable-line